import React, {Component} from 'react';
import SessionStore from "../../util/sessionStore";
import {COMMON_SEARCH_CONDITION, ADVANCE_SEARCH_CONDITION} from "../../config/localStoreKey";
import PureRenderMixin from 'react-addons-pure-render-mixin'
import moment from 'moment';

import InputDataList from '../InputDataList';
import styled from 'styled-components';

class CheckBox extends Component {
    constructor() {
        // noinspection JSCheckFunctionSignatures
        super(...arguments);
        // 性能优化向
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.onChange = this.onChange.bind(this);
        CheckBox.localStore = CheckBox.localStore.bind(this);

    }


    render() {
        // console.log("condition--->", this.props.getCondition(COMMON_SEARCH_CONDITION), this.props.getCondition(ADVANCE_SEARCH_CONDITION))


        let condition = this.props.getCondition(COMMON_SEARCH_CONDITION) || "";
        let advanceCondition = this.props.getCondition(ADVANCE_SEARCH_CONDITION);
        let searchInfo = this.props.searchInfo;
        let searchCondition = searchInfo.searchCondition;
        return (
            <div>
                {COMMON_SEARCH_CONDITION === searchCondition ?
                    <div className="checkBox">
                        <div className="search mt50 mb50">
                            <div className="searchBar">
                                <input type="text" id="condition" value={condition}
                                       onChange={this.onChange} placeholder="请输入书名"/>

                            </div>
                            <button type="button" style={{marginLeft: '10px'}} onClick={this.props.bookSearch}
                                    className="btn">搜 索
                            </button>


                            <button type="button" className="btn" onClick={this.props.commClean} style={{marginLeft: 5}}
                            >清 空
                            </button>
                            <div className="font">（请根据相应的字段输入相关关键字进行检索）</div>
                        </div>
                    </div> :
                    <div className="checkBox">
                        <ul>
                            <li>
                                <b>书名:</b>
                                <span><input className="inputs firstInput" value={advanceCondition.title}
                                             style={{marginLeft: '23px'}}
                                             id="title"
                                             onChange={this.onChange} type="text"/></span>
                            </li>
                            <li>
                                <b>作者:</b>
                                <span><input className="inputs" value={advanceCondition.author} id="author"
                                             onChange={this.onChange} style={{marginLeft: '23px'}} type="text"/></span>
                            </li>
                            <li>
                                <b>主题词:</b>
                                <span><input className="inputs lastInput" value={advanceCondition.keyword} id="keyword"
                                             onChange={this.onChange} type="text"/></span>
                            </li>
                            <li>
                                <b>出版者:</b>
                                <span><input className="inputs" value={advanceCondition.publisher} id="publisher"
                                             onChange={this.onChange} type="text"/></span>
                            </li>
                            <li style={{height: '40px'}}>
                                <b style={{float: "left", paddingTop: "10px"}}>出版时间:</b>
                                <span style={{float: "left"}}>
                                <InputDataList inputId={"publish_year_start"}
                                               listId="publish_year_start_list"
                                               options={this.getYears()}
                                               yearOnChange={this.onChange}
                                               defaultValue={advanceCondition.publish_year_start}
                                />
                            </span>
                                <span className="zhi">至</span>
                                <span style={{float: "left"}}>
                                <InputDataList inputId={"publish_year_end"}
                                               listId="publish_year_end_list"
                                               options={this.getYears()}
                                               yearOnChange={this.onChange}
                                               defaultValue={advanceCondition.publish_year_end}
                                />
                            </span>
                            </li>
                            <li>
                                <b>索书号:</b>
                                <span><input className="inputs lastInput"
                                             value={advanceCondition.callno} id="callno"
                                             onChange={this.onChange} type="text"/></span>
                            </li>

                            <li>
                                <b>条码号:</b>
                                <span><input className="inputs" value={advanceCondition.book_barcode}
                                             style={{marginLeft: '10px'}}
                                             id="book_barcode"
                                             onChange={this.onChange} type="text"/></span>
                            </li>
                            <li>
                                <b>馆藏地:</b>
                                <span><input className="inputs" value={advanceCondition.book_current_place_name}
                                             style={{marginLeft: '10px'}}
                                             id="book_current_place_name"
                                             onChange={this.onChange} type="text"/></span>
                            </li>
                            <li style={{float: 'right', marginRight: '50px'}}>
                                <div className={"buttonPosition"}>
                                    <button type="button" className="btn" onClick={this.props.bookSearch}>搜 索</button>
                                    <button type="button" className="btn" onClick={this.props.clear}
                                            style={{marginLeft: 5}}>清 空
                                    </button>
                                </div>
                            </li>
                        </ul>
                    </div>
                }
            </div>
        )
    }

    // 查询条件 先从store 读入，如果没有 读取本地localStore, 并将数据存入store
    componentDidMount() {

    }


    // 监听输入数据 并存入本地
    onChange(e) {
        let searchInfoActions = this.props.searchInfoActions;
        let searchInfo = this.props.searchInfo;
        let condition = this.props.getCondition(COMMON_SEARCH_CONDITION);
        let advanceCondition = this.props.getCondition(ADVANCE_SEARCH_CONDITION);
        let re = /^[1-2]?[0-9]{0,3}$/;
        if (e.target.id === "condition") {
            condition = e.target.value
        } else if (e.target.id === "title") {
            advanceCondition.title = e.target.value;
        } else if (e.target.id === "author") {
            advanceCondition.author = e.target.value;
        } else if (e.target.id === "keyword") {
            advanceCondition.keyword = e.target.value;
        } else if (e.target.id === "publisher") {
            advanceCondition.publisher = e.target.value;
        } else if (e.target.id === "publish_year_start") {
            // 判断是只包含数字
            // console.log("publish_year_start   ", e.target.value);
            if (!re.test(e.target.value) || e.target.value === "0" || e.target.value === 0) {
                return;
            }

            advanceCondition.publish_year_start = e.target.value;
        } else if (e.target.id === "publish_year_end") {
            if (!re.test(e.target.value) || e.target.value === "0" || e.target.value === 0) {
                return;
            }
            advanceCondition.publish_year_end = e.target.value;
        } else if (e.target.id === "callno") {
            // console.log("callno------->", e.target.value)
            advanceCondition.callno = e.target.value;
        } else if (e.target.id === "book_barcode") {
            // console.log("book_barcode is ", e.target.value);
            advanceCondition.book_barcode = e.target.value;
        } else if (e.target.id === "book_current_place_name") {
            // console.log("book_barcode is ", e.target.value);
            advanceCondition.book_current_place_name = e.target.value;
        }
        searchInfoActions.bookSearch(
            {
                ...searchInfo, advanceCondition: {...advanceCondition}, condition
            }
        );
        CheckBox.localStore(e.target.id === "condition" ? COMMON_SEARCH_CONDITION : ADVANCE_SEARCH_CONDITION);
    }

    // 在点击的过程中将数据 存入到本地，保证返回时候回有相关数据
    static localStore(searchCondition) {

        // let searchInfo = this.props.searchInfo;
        // let searchCondition = searchInfo.searchCondition;
        // console.log("searchCondition====>", searchCondition);


        if (searchCondition === COMMON_SEARCH_CONDITION) {
            let condition = document.getElementById("condition").value;
            SessionStore.setSessionItem(COMMON_SEARCH_CONDITION, condition);
        } else {
            let title = document.getElementById("title").value;
            let author = document.getElementById("author").value;
            let keyword = document.getElementById("keyword").value;
            let publisher = document.getElementById("publisher").value;
            let publish_year_start = document.getElementById("publish_year_start").value;
            let publish_year_end = document.getElementById("publish_year_end").value;
            let callno = document.getElementById("callno").value;
            let book_barcode = document.getElementById("book_barcode").value;
            let book_current_place_name = document.getElementById("book_current_place_name").value;
            SessionStore.setSessionItem(ADVANCE_SEARCH_CONDITION, JSON.stringify({
                title: title,
                author: author,
                keyword: keyword,
                publisher: publisher,
                publish_year_start: publish_year_start,
                publish_year_end: publish_year_end,
                callno: callno,
                book_barcode: book_barcode,
                book_current_place_name: book_current_place_name,
            }))
        }


    }

    // 获取年份列表 当前日期向后退50年
    // noinspection JSMethodCanBeStatic
    getYears() {
        let year = moment().format('YYYY') - 0;
        let years = [];

        for (let i = 0; i < 50; i++) {
            years.push(year - i);
        }
        return years;
    }


    searchBar() {
        let searchBar = document.querySelector(".searchBar a");
        let searchBarSelect = document.querySelector(".searchBarSelect");

        if (hasClass(searchBar, "active")) {
            searchBar.classList.remove("active");
            searchBarSelect.style.display = "none";
        } else {
            searchBar.classList.add("active");
            searchBarSelect.style.display = "block";
        }
    }

    // searchBarSelect(e) {
    //     console.log(e.target.innerHTML);
    //
    //     let searchInfoActions = this.props.searchInfoActions;
    //     let searchInfo = this.props.searchInfo;
    //     let condition = e.target.innerHTML;
    //
    //     searchInfoActions.bookSearch(
    //         {
    //             ...searchInfo, condition
    //         }
    //     );
    //     CheckBox.localStore();
    //     let searchBarSelect = document.querySelector(".searchBarSelect");
    //     let searchBarA = document.querySelector(".searchBar a");
    //     let allSpan = document.querySelectorAll(".searchBarSelect span");
    //
    //     for (let i = 0; i < allSpan.length; i++) {
    //         allSpan[i].classList.remove("active");
    //     }
    //
    //     searchBarSelect.style.display = "none";
    //     searchBarA.classList.remove("active");
    // }


}


//判断是否有class；
function hasClass(ele, cls) {
    return ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}

const ButtonStyleSolid = styled.button`
	height: 38px;
	color: white;
	font-size: 15px;
	padding: 0.5em 1em;
	background: #0c9ce3;
	border: 0px;
	border-radius: 0px;
	width: 150px;
`;


export default CheckBox;



// WEBPACK FOOTER //
// ./src/components/home/CheckBox.js